/**
 * The prompt clause for text Gemini renders ON an image. One line is the plain
 * instruction it always was. Several lines are a headline plus smaller lines (a
 * brief's mandatory "Always read the label…"), so the hierarchy is spelled out —
 * left implicit, Gemini runs them together as one small caption joined by "|".
 * (POR-14794)
 *
 * @param {string|null} overlayText
 * @returns {string} '' when there is no text
 */
export function overlayTextPrompt(overlayText) {
  const lines = String(overlayText || '')
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);

  if (!lines.length) {
    return '';
  }
  if (lines.length === 1) {
    return ` Overlay text to render in the image: "${lines[0]}".`;
  }

  const [headline, ...smallPrint] = lines;
  return ` Overlay text to render in the image, each text exactly as written: the headline "${headline}", large and prominent; `
    + `then, on its own line below it and much smaller: ${smallPrint.map((line) => `"${line}"`).join(', then ')}. `
    + 'Keep them as separate lines — do not merge them into one line or add separators such as "|".';
}
